import { IconEggCracked } from '@tabler/icons-react';
import type { TRPC_ERROR_CODE_KEY } from '@trpc/server/rpc';

const UnAuthorizedError = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <h2 className="text-center font-medium">Uh oh, it seems like you don&apos;t have access to this page </h2>
      <div className="dark: mt-2 text-center text-gray-700 dark:text-gray-400">
        You may not be part of the organization yet. <br />
        Please contact your admin to add you.
      </div>
    </div>
  );
};

export default function HttpError({ errorCode, httpStatus }: { errorCode?: TRPC_ERROR_CODE_KEY; httpStatus?: number }) {
  return (
    <div className="flex flex-col items-center justify-center gap-4">
      <IconEggCracked
        size={60}
        stroke={2}
      />
      {errorCode === 'UNAUTHORIZED' ?
        <UnAuthorizedError />
      : <div>
          <span>
            {httpStatus}-{errorCode}
          </span>
        </div>
      }
    </div>
  );
}
